module.exports = __webpack_public_path__ + "static/img/4hexin.a0a4368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/4hexin.png
// module id = hLEM
// module chunks = 0